module.exports = __webpack_public_path__ + "static/media/CHANGELOG.462fc4c6.md";